<div class="ups-logo">
    <img [src]="imageLink" class="img-responsive" alt="ParcelPro">
</div>
